import type { ReactElement } from "react";

import { useDispatch, useSelector } from "react-redux";

import type { BaseActivatedPanelProps } from "app/pages/sales-intelligence/common-components/table-actions-panel";
import { selectActiveLeadsType, selectActiveSearchResultsDto } from "app/pages/sales-intelligence/modules/leads-search";
import { selectIsAccountsExportInProgress } from "app/pages/sales-intelligence/modules/crm-export/store/selectors";

import { startLeadsAccountsCrmExportThunk } from "../../../store/effects";

import CrmExportPanelContainer from "./CrmExportPanelContainer";

const HubSpotExportPanelContainer = (props: BaseActivatedPanelProps): ReactElement => {
    const dispatch = useDispatch();

    const exportIsInProgress = useSelector(selectIsAccountsExportInProgress);
    const activeLeadsType = useSelector(selectActiveLeadsType);
    const searchResultsDto = useSelector(selectActiveSearchResultsDto);

    const handleExportNDomains = (domainsCount: number, countries: readonly number[]) => {
        void dispatch(
            startLeadsAccountsCrmExportThunk({
                integration: "hubspot",
                leadsType: activeLeadsType,
                countries,
                domainsCount,
                dto: searchResultsDto,
            }),
        );
    };

    const handleExportDomains = (domains: readonly string[], countries: readonly number[]) => {
        void dispatch(
            startLeadsAccountsCrmExportThunk({
                integration: "hubspot",
                leadsType: activeLeadsType,
                countries,
                domains,
            }),
        );
    };

    return (
        <CrmExportPanelContainer
            integration="hubspot"
            isExportInProgress={exportIsInProgress}
            label={{ key: "si.multi_selector.hubspot.title" }}
            onDeactivate={props.onDeactivate}
            onExportNDomains={handleExportNDomains}
            onExportDomains={handleExportDomains}
        />
    );
};

export default HubSpotExportPanelContainer;
